import React from 'react'
import { Paragraph } from '../components/paragraph/Paragraph'

export function Subtitling() {
  return (
    <React.Fragment>
      <Paragraph>
        If you have a video that requires interlingual subtitling, I can offer stylistically appealing and fluid captioning with a fast turnaround.
      </Paragraph>
      <Paragraph>
        When creating subtitles for a foreign audience, I strive to not only convey the message accurately, but will also localise cultural nuances; adapt the text to the audience, purpose and context; abbreviate sentences so that they can be read and understood in time with the video, and offer different levels of editing depending on the needs of the target audience.
      </Paragraph>
      <Paragraph>
        I recently translated and subtitled the content of a health and lifestyle course by a prominent Italian celebrity. As part of this, I became adept at adhering to strict criteria in terms of respecting certain reading speeds and characters per line, and researching his fan base in order to convey the appropriate register.
      </Paragraph>
    </React.Fragment>
  )
}
